import { LayoutWithSidebar } from 'utils/router/components/LayoutWithSidebar/LayoutWithSidebar'

import { AiAutomationLayout } from './components/AiAutomationLayout'
import { AI_AUTOMATION_ROUTE_ITEMS } from './routeItems'

export const AiAutomationRoutes = [
  {
    path: 'ai',
    Component: LayoutWithSidebar,
    alias: 'aiAutomation',
    children: [
      {
        path: '',
        Component: AiAutomationLayout,
        children: [
          {
            index: true,
            lazy: () => import('./aiAutomation.page'),
          },
          ...AI_AUTOMATION_ROUTE_ITEMS,
          { path: 'playground', alias: 'aiPlayground', lazy: () => import('./Playground') },
        ],
      },
    ],
  },
] as const
